import useDictionary from "../../hooks/useDictionary";

//import { useParams } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";

export default function S2B2BUploadPhotoForm({ onSuccess, userId, userHash }) {

    const dictionary = useDictionary();
    
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState(false);
    
    //const params = useParams();

    const [uploaded, setUploaded] = useState(false);

    const inputRef = useRef(null);
    const headerRef = useRef(null);

    const handleSubmit = () => {
        onSuccess(uploaded);
    }

    useEffect(() => {
        headerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, []); // tylko przy montowaniu

    // upload pliku
    const [preview, setPreview] = useState(null);   // podgląd zdjęcia
    const [status, setStatus]   = useState('idle'); // idle | uploading | done | error
    const [progress, setProgress] = useState(0);
    const [message, setMessage]   = useState('');    

    function handleFile(file) {
   
        if (!file) return;

        // walidacja po stronie klienta
        const allowed = ['image/jpeg', 'image/png', 'image/webp'];
        if (!allowed.includes(file.type)) {
        setMessage(dictionary.ACCEPTED_FORMAT + ': JPG, PNG, WEBP');
        setStatus('error');
        return;
        }
        if (file.size > 5 * 1024 * 1024) {
        setMessage(dictionary.FILE_TO_BIG);
        setStatus('error');
        return;
        }

        // podgląd przed uploadem
        setPreview(URL.createObjectURL(file));
        setStatus('idle');
        setMessage('');

        uploadFile(file);
   
    }

    function uploadFile(file) {
        setLoading(true);
        setStatus('uploading');
        setProgress(0);

        const formData = new FormData();
        formData.append('userId',   userId);    // pole 1
        formData.append('userHash', userHash);  // pole 2
        formData.append('photo',    file);      // plik — nazwa 'photo' musi zgadzać się z $_FILES['photo'] w PHP

        // XHR zamiast fetch — potrzebujemy progress
        const xhr = new XMLHttpRequest();

        xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
            setProgress(Math.round((e.loaded / e.total) * 100));
        }
        };

        xhr.onload = () => {
        if (xhr.status === 200) {
            setStatus('done');
            setLoading(false);
            setMessage(dictionary.FILE_ADDED);
        } else {
            setStatus('error');
            setLoading(false);
            setMessage(`Error: ${xhr.status}`);
        }
        };

        xhr.onerror = () => {
        setStatus('error');
        setMessage('Connection error');
        setLoading(false);
        };

        xhr.open('POST', 'https://api.negativbrand.com/pl/api/registerb2bphotos');
        // NIE ustawiaj Content-Type — przeglądarka sama doda multipart/form-data z boundary
        xhr.send(formData);
        setUploaded(true);
        setLoading(false);
    }    

    function handleDrop(e) {
        e.preventDefault();
        handleFile(e.dataTransfer.files[0]);
    }

    return (
        <>
        <div>
                <div className={`overlay-loading ${loading ? '' : 'default-hidden'}`}><span className="loader"><span>Chwileczkę...</span></span><div className="shadow"></div></div>

                <div className="univ-text" ref={headerRef}>
                    <p>{dictionary.PHOTOS_INFO}</p>
                </div>

                <div className="univ-form-header">
                    {dictionary.ADD_PHOTOS}
                </div>

                <div className="photo-controls">

                    <div className="photo-preview">
                    {preview
                        ? <img src={preview} alt="Preview" />
                        : <p>{dictionary.CLICK_TO_ADD_PHOTOS}</p>
                        }
                    </div>

                    <div className="photo-progress">
                    {status === 'uploading' && (
                        <div style={{ marginTop: 12 }}>
                        <div style={{ background: '#eee', borderRadius: 4, height: 6 }}>
                            <div style={{
                            width: `${progress}%`
                            }} className="progress-bar" />
                        </div>
                        <p style={{ fontSize: 12, marginTop: 6, color: '#666' }}>{progress}%</p>
                        </div>
                    )}
                    </div>

                    {status === 'done'  && <p style={{ color: 'green',  marginTop: 8 }}>✓ {message}</p>}
                    {status === 'error' && <p style={{ color: 'red',    marginTop: 8 }}>✗ {message}</p>}

                </div>

                <div className="univ-form-fields">
                    <input type="file" className="default-hidden" ref={inputRef} onChange={e => handleFile(e.target.files[0])} accept="image/jpeg,image/png,image/webp" />

                    <div className="univ-form-upload-file">
                        <button onClick={() => inputRef.current.click()} onDragOver={e => e.preventDefault()} onDrop={handleDrop}>
                            <FontAwesomeIcon icon={faUpload} />
                            <span>{dictionary.SELECT_FILE}<br />(jpg, png lub webp)</span>
                        </button>
                    </div>

                </div>

                <div className="univ-submit-button">
                    {apiError && <div style={{ color: "red", padding: "1rem" }}>{dictionary.SERVER_ERROR} :-(</div>}
                    <button onClick={handleSubmit} disabled={loading}>{uploaded ? dictionary.FINISH_BUTTON : dictionary.SKIP_BUTTON }</button>
                </div>

        </div>

        </>
    )

}